import React from "react";
import { IoMdLink } from "react-icons/io";
import { FaShareAlt } from "react-icons/fa";

import { useTranslation } from "react-i18next";

import { getLoadingImage } from "../constants/images";

import useProgressiveImg from "../utils/ProgressiveImg";



const ComicItem = ({className = "", item, togglePopup, urlPart}) => {

    const { t } = useTranslation();

    // Cargar la imagen del comic y la imagen default que se va a mostrar cuando se carge el comic
    const [src, { blur }] = useProgressiveImg(getLoadingImage(item.id), item.url);


    return (
        <div className={`mb-9 size-full ${className}`}>

            <img
                src={src}
                className="size-full px-2" 
                style={{
                    filter: blur ? "blur(20px)" : "none",
                    transition: blur ? "none" : "filter 0.3s ease-out"
                }}
            />


            <div className="p-4">

                {item.script_credit === item.art_credit ? (
                    <p className="mt-1 font-bold text-base" align="center">
                        {t('Script and art by')}&nbsp;{item.script_credit}
                    </p>
                ) : (
                    <p className="mt-1 font-bold text-base" align="center">
                        {t('Script')}:&nbsp;{item.script_credit}   &ensp;/&ensp;   {t('Art')}:&nbsp;{item.art_credit}
                    </p>
                )}


                <div className="flex flex-row justify-center gap-x-28 mt-9 text-blue-900">

                    <p onClick={() => window.location.href = urlPart + `/comic/${item.id}`}>
                        <div className="flex flex-col items-center">
                                <IoMdLink className="w-8 h-8"/>
                                <h4 className="font-bold text-sm md:text-base mt-2.5">
                                    {t('Direct Link')}
                                </h4>
                        </div>
                    </p>

                    <div className="flex flex-col items-center" onClick={() => togglePopup(urlPart + `/comic/${item.id}`)}>
                        <FaShareAlt className="w-8 h-8" />
                        <h4 className="font-bold text-sm md:text-base mt-2.5">
                            {t('Share')}
                        </h4>
                    </div>
                </div>
            </div>


        </div>
    );
}; 

export default ComicItem; 